<template>
  <div class="yhc-component yhc-fzc-black PrivateEndLabel endLabel" :style="endLabelStyle" @click="tapEndLabel">
    <el-button v-if="isBtnEndLabel" :type="endLabelType" size="mini">
      {{ endLabel }}
    </el-button>
    <div v-else>{{ endLabel }}</div>
  </div>
</template>

<script>
let identifierName = 'PrivateEndLabel'

export default {
  name: identifierName,
  props: {
    endLabel: {
      type: String,
      require: true,
    },
    isBtnEndLabel: {
      type: Boolean,
      default: false,
    },
    endLabelType: {
      type: String,
      default: 'danger',
    },
    endLabelStyle: {
      type: Object,
      default: function () {
        return {}
      },
    },
  },
  methods: {
    tapEndLabel() {
      this.$emit('tapEndLabel', this.endLabel)
    },
  },
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.PrivateEndLabel {
  font-size: 14px;
}
</style>
